module.exports = __webpack_public_path__ + "img/Rignt Image.95a9991a.png";